import type { JSX } from 'react';

import { useKnownAvailableParams } from '@change-corgi/core/react/router';
import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';

import { withPrefetchedData } from 'src/shared/prefetch';

import type { LocalPagePrefetchedDataProps } from 'src/app/pages/local/pageContext';
import { LocalPageContextProvider, prefetchPageContext } from 'src/app/pages/local/pageContext';

import { Layout } from '../layout';

import { LocalErrorHandler } from './ErrorHandler';

export const Local = withPrefetchedData(
	function Local({ prefetchedData }: LocalPagePrefetchedDataProps): JSX.Element {
		const { slug } = useKnownAvailableParams<{ slug: string }>();

		return (
			<LocalPageContextProvider
				slug={slug}
				prefetchedData={prefetchedData}
				errorHandler={LocalErrorHandler}
				loadingFallback={<Loader size="m" my={256} mx="auto" />}
			>
				<Layout />
			</LocalPageContextProvider>
		);
	},
	{
		prefetchName: __MODULE_HASH__,
		// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
		prefetchData: async (context) => prefetchPageContext(context.params.slug!, context),
	},
);
